/**
 * Step 2A の「ブラウザで再生のみ」(VIEW) ラジオ用の小アイコン。
 * 再生三角を円で囲んだだけのシンプルな記号で、隣の {@link ShareDownloadIcon}
 * と並べた時に「再生」だけ持つことが視覚的に対比される。
 */
export function ShareViewIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 28 28"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <circle cx="14" cy="14" r="11" />
      <path d="M11 9 L19 14 L11 19 Z" fill="currentColor" stroke="none" />
    </svg>
  )
}
